import { useEffect, useState } from "react";
import { IsLoading, VideoForm } from "../components";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../constants";
import axios from "axios";
import { DocumentTitle } from "../utils";

const UpdateVideo = () => {
    const { id } = useParams();
    const [video, setVideo] = useState(null);
    DocumentTitle(`IVY ${video && `| ${video.title}`}`);

    const updateVideo = async (formData) => {
        try {
            const res = await axios.put(`${BASE_URL}/video/updateVideo.php?id=${id}`, formData);
            const resObject = await res.data;

            return resObject;
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        axios.get(`${BASE_URL}/decrypt.php?text=${id}`).then(res => {
            if (res.status == 200) {
                axios.get(`${BASE_URL}/video/index.php?id=${res.data}`).then(res => {
                    if (res.status == 200) {
                        setVideo(res.data)
                    }
                }).catch(error => console.log(error))
            }
        }).catch(error => console.log(error))
    }, [id])

    if (!video) return <IsLoading />
    return (
        <VideoForm video={video} handleFormAction={updateVideo} />
    )
}

export default UpdateVideo